export const serverHost = "http://parentalcareapi.padaidunia.com/";